/**
 * @generated SignedSource<<91efb3afaa697902ba92133659624f3c>>
 * @relayHash 44d72e6938791259ff5fa085acc1952b
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 44d72e6938791259ff5fa085acc1952b

import { ConcreteRequest } from 'relay-runtime';
export type parseNodeIdQuery$variables = {
  nodeId: string;
};
export type parseNodeIdQuery$data = {
  readonly parseNodeId: {
    readonly internalId: string;
    readonly internalIdRuntimeType: string;
    readonly typeName: string;
  } | null;
};
export type parseNodeIdQuery = {
  response: parseNodeIdQuery$data;
  variables: parseNodeIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "nodeId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "nodeId",
        "variableName": "nodeId"
      }
    ],
    "concreteType": "ParsedNodeIdOutput",
    "kind": "LinkedField",
    "name": "parseNodeId",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "typeName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "internalId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "internalIdRuntimeType",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "parseNodeIdQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "parseNodeIdQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "44d72e6938791259ff5fa085acc1952b",
    "metadata": {},
    "name": "parseNodeIdQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "d1d45fb7269b18b9ffeec8c2229c8e06";

export default node;
